import { render, staticRenderFns } from "./BasketDisplayer.vue?vue&type=template&id=442ed225&scoped=true&"
import script from "./BasketDisplayer.vue?vue&type=script&lang=js&"
export * from "./BasketDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./BasketDisplayer.vue?vue&type=style&index=0&id=442ed225&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442ed225",
  null
  
)

export default component.exports